const CommonSidebar = () => import(/* webpackChunkName: "component.header" */ '@/components/Sidebar');
const CommonHeader = () => import(/* webpackChunkName: "component.header" */ '@/components/Header');
const CommonFooter = () => import(/* webpackChunkName: "component.header" */ '@/components/Footer');

export default {
  path: 'my-account',
  components: {
    sidebar: CommonSidebar,
    header: CommonHeader,
    footer: CommonFooter,
    default: () => import(/* webpackChunkName: "module.account" */ '@/views/Account'),
  },
  meta: {
    navigation: {
      title: 'My Account',
        menu: [
        'my-profile',
        'my-company',
      ],
    },
    breadcrumb: {
      label: 'My Account',
    },
  },
  children: [
    {
      path: '',
      name: 'my-profile',
      component: () => import(/* webpackChunkName: "module.account.profile" */ '@/modules/MyProfile'),
      meta: {
        navigation: {
          link: {
            icon: 'user-alt',
            label: 'My Profile',
          },
        },
        breadcrumb: {
          parent: 'dashboard',
          label: 'My Profile',
        },
      },
    },
  ],
};
